import React from "react";
import { Card, Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import UserCard from "./UserCard";

const ProfileCard = ({ data }) => {
  const { t } = useTranslation();

  return (
    <>
      <Col lg={3}>
        <UserCard userData={data} commission={data?.commission} />
      </Col>
      <Col lg={9}>
        <Card bg="dark1 text-light h-100">
          <Card.Body>
            <Row>
              <Col lg={4}>
                <h6>{t("signup.personalData")}</h6>

                <ul className="list-unstyled user-data my-4">

                  {data?.orgUser?.type === "COMPANY" ? (
                    <li className="text-capitalize mobile-detail-row">
                      <span>{t("form.companyName")}:</span>
                      <span>{data?.orgUser?.company_name}</span>
                    </li>
                  ) : (
                    <li className="text-capitalize mobile-detail-row">
                      <span>{t("form.name")}:</span>
                      <span>
                        {data?.user?.first_name} {data?.user?.last_name}
                      </span>
                    </li>
                  )}

                  <li className="text-capitalize mobile-detail-row">
                    <span>{t("form.email")}:</span>
                    <span className="text-lowercase">{data?.user?.email}</span>
                  </li>

                  <li className="text-capitalize mobile-detail-row">
                    <span>{t("form.mobileNumber")}:</span>
                    <span>{data?.user?.phone}</span>
                  </li>

                  <li className="text-capitalize mobile-detail-row">
                    <span>{t("form.telephone")}:</span>
                    <span>{data?.orgUser?.telephone}</span>
                  </li>

                  <li className="text-capitalize mobile-detail-row">
                    <span>{t("form.dob")}:</span>
                    <span>{data?.orgUser?.date_of_birth}</span>
                  </li>

                  <li className="text-capitalize mobile-detail-row">
                    <span>{t("form.sex")}:</span>
                    <span>{data?.orgUser?.sex}</span>
                  </li>

                  <li className="text-capitalize mobile-detail-row">
                    <span>{t("form.typology")}:</span>
                    <span>{data?.orgUser?.type}</span>
                  </li>

                  <li className="text-capitalize mobile-detail-row">
                    <span>{t("form.taxId")}:</span>
                    <span>{data?.orgUser?.tax_code}</span>
                  </li>

                  <li className="text-capitalize mobile-detail-row">
                    <span>{t("form.pec")}:</span>
                    <span>{data?.orgUser?.PEC}</span>
                  </li>

                  {data?.user?.userRoles?.role_name === "Collaborator" && (
                    <li className="text-capitalize mobile-detail-row">
                      <span>{t("referralCode")}:</span>
                      <span>{data?.orgUser?.referral_code}</span>
                    </li>
                  )}

                  <li className="text-capitalize mobile-detail-row">
                    <span>{t("form.affiliateCode")}:</span>
                    <span>{data?.orgUser?.affiliate_code}</span>
                  </li>

                </ul>
              </Col>

              <Col lg={4}>
                <h6>{t("signup.residence")}</h6>

                <ul className="list-unstyled user-data my-4">
                  <li className="text-capitalize mobile-detail-row">
                    <span>{t("form.address")}:</span>
                    <span>{data?.orgUser?.address}</span>
                  </li>

                  <li className="text-capitalize mobile-detail-row">
                    <span>{t("form.country")}:</span>
                    <span>{data?.orgUser?.province}</span>
                  </li>

                  <li className="text-capitalize mobile-detail-row">
                    <span>{t("form.city")}:</span>
                    <span>{data?.orgUser?.city}</span>
                  </li>

                  <li className="text-capitalize mobile-detail-row">
                    <span>{t("form.postcode")}:</span>
                    <span>{data?.orgUser?.postcode}</span>
                  </li>
                </ul>
              </Col>

              <Col lg={4}>
                <h6>{t("signup.domicile")}</h6>

                <ul className="list-unstyled user-data my-4">
                  <li className="text-capitalize mobile-detail-row">
                    <span>{t("form.address")}:</span>
                    <span>{data?.orgUser?.address_home}</span>
                  </li>

                  <li className="text-capitalize mobile-detail-row">
                    <span>{t("form.country")}:</span>
                    <span>{data?.orgUser?.province_home}</span>
                  </li>

                  <li className="text-capitalize mobile-detail-row">
                    <span>{t("form.city")}:</span>
                    <span>{data?.orgUser?.city_home}</span>
                  </li>

                  <li className="text-capitalize mobile-detail-row">
                    <span>{t("form.postcode")}:</span>
                    <span>{data?.orgUser?.postcode_home}</span>
                  </li>
                </ul>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </Col>
    </>
  );
};

export default ProfileCard;
